import styled from 'styled-components';

const Midground = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
  background: var(--elevation-mid);
  min-width: 0;

  box-sizing: border-box;
`;

export { Midground };
